export const FILE_UPLOAD_LABELS = {
  MAX_FILES_MESSAGE_SINGULAR: 'Możesz przesłać maksymalnie 1 plik.',
  MAX_FILES_MESSAGE_PLURAL: 'Możesz przesłać maksymalnie {count} pliki.',
  SUPPORTED_FORMATS_PREFIX: 'Obsługiwane typy plików:',
  MAX_FILE_SIZE: 'Maksymalny rozmiar pliku:',
  BROWSE_FILES: 'Przeglądaj pliki',
  DRAG_DROP_SINGULAR: 'Wybierz plik lub przeciągnij i upuść go tutaj',
  DRAG_DROP_PLURAL: 'Wybierz plik lub przeciągnij i upuść go tutaj',
  BROWSE: 'browse',
  REMOVE_FILE: 'Usuń plik',
  CANCEL_UPLOAD: 'Anuluj przesyłanie',
  UPLOAD_ERROR: 'Błąd serwera. Spróbuj ponownie.',
  RETRY_UPLOAD: 'Ponów przesyłanie',
};

export enum FileType {
  PNG = 'PNG',
  JPG = 'JPG',
  JPEG = 'JPEG',
  PDF = 'PDF',
  DOC = 'DOC',
  DOCX = 'DOCX',
  XLS = 'XLS',
  XLSX = 'XLSX',
  CSV = 'CSV',
  TXT = 'TXT',
}

export const FILE_TYPE_CONFIG: Record<
  FileType,
  { mimeType: string; maxSize: number }
> = {
  [FileType.PNG]: { mimeType: 'image/png', maxSize: 5 },
  [FileType.JPG]: { mimeType: 'image/jpeg', maxSize: 5 },
  [FileType.JPEG]: { mimeType: 'image/jpeg', maxSize: 5 },
  [FileType.PDF]: { mimeType: 'application/pdf', maxSize: 5 },
  [FileType.DOC]: { mimeType: 'application/msword', maxSize: 5 },
  [FileType.DOCX]: {
    mimeType:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    maxSize: 5,
  },
  [FileType.XLS]: { mimeType: 'application/vnd.ms-excel', maxSize: 5 },
  [FileType.XLSX]: {
    mimeType:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    maxSize: 5,
  },
  [FileType.CSV]: { mimeType: 'text/csv', maxSize: 5 },
  [FileType.TXT]: { mimeType: 'text/plain', maxSize: 5 },
};
